import React from "react";
import styles from "./styles/BankTransfer.scss";
import { Descriptions } from "antd";
import { BankTransferInfoColumns, BankTransferInfoText, ShoppingCartItemType, ShoppingCartParsed } from "../../models";

export interface IBankTransferProps {
  cart: ShoppingCartParsed;
}

const BankTransfer = (props: IBankTransferProps) => {
  const { cart } = props;

  return (
    <React.Fragment>
      <p className={styles.title}>
        {cart.type === ShoppingCartItemType.Promotion && "Prilikom plaćanja uplatnicom, koristi dolje navedene podatke. Popuni ih ispravno kako bi što prije istaknuli tvoj oglas. Plaćanje možeš izvršiti u bilo kojem poštanskom uredu ili korištenjem internet bankarstva. Usluga će biti aktivirana u roku od 1 do 3 radna dana."}
        {cart.type === ShoppingCartItemType.StoreCredit && "Prilikom plaćanja uplatnicom, koristi dolje navedene podatke. Popuni ih ispravno kako bi ti što prije dodali kredite na stanje. Plaćanje možeš izvršiti u bilo kojem poštanskom uredu ili korištenjem internet bankarstva. Sredstva će bit dostupna u roku od 1 do 3 radna dana."}
      </p>

      <Descriptions bordered column={1}
        className={styles.tableDescription}
        size="small"
      >
        {BankTransferInfoText.map((item) => (
          <Descriptions.Item key={item.value} label={item.label} className={styles.tableItem}>
            {item.value === BankTransferInfoColumns.barcode ? (
              <img className={styles.barcodeImg} src={"data:image/png;base64, " + cart.bankTransferInfo[item.value]} alt="barcode" />
            ) : (
              cart.bankTransferInfo[item.value]
            )}

          </Descriptions.Item>
        ))}
      </Descriptions>
    </React.Fragment>
  );
};

export default BankTransfer;




// WEBPACK FOOTER //
// ./src/components/BankTransfer/index.tsx